import Helpers from '@intelingu/core/helpers/Helpers';
import classnames from 'classnames';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { SubscriptionStatus, UserSubscription } from '@intelingu/core/interfaces/models/UserSubscriptionModel';
import moment from 'moment';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {COMMON_NS} from "@intelingu/core/constants/base.constants";
import withTranslation from "@intelingu/core/utils/withTranslation";
import {SubscriptionsApi} from "@intelingu/core/api/SubscriptionsApi";
import {lazyInject} from "@intelingu/core/IoC/container";

export interface SubscriptionItemProps {
    subscription: UserSubscription;
    t?;
}

@withTranslation(COMMON_NS)
@observer export class SubscriptionItem extends Component<SubscriptionItemProps, any> {

    @lazyInject(SubscriptionsApi) subscriptionsApi: SubscriptionsApi;

    @observable isViewVisible = false;
    @observable isModalVisible = false;
    @observable isCancelledVisible = false;

    @action.bound toggleCancelModal() {
        this.isModalVisible = !this.isModalVisible;
    }

    @action.bound unsubscribe() {
        // unsubscribe API action
    }

    @action.bound renew() {
        // renew API action
    }

    @action.bound changePaymentMethod() {
        // change payment method action
    }

    @action.bound async cancel() {
        // window.location = this.props.subscription.ds24_rebilling_stop_url as any;
        this.isModalVisible = false;
        this.isCancelledVisible = true;
        await this.subscriptionsApi.unsubscribe(this.props.subscription.ds24_order_id);
    }

    _getExpireMessage() {
        const {
            t,
            subscription: {
                interval,
                is_trial,
                is_trial_native,
                order_date,
                access_stops_on
            }
        } = this.props;

        if (interval > 0) {
            const endDate = ` ${Helpers.calculateEndDate(this.props.subscription)}`;

            if (is_trial_native && moment.unix(order_date).add(7, 'days').isAfter(moment()) && !access_stops_on) {
                return 'Abbuchung erfolgt am: ' + moment.unix(order_date).add(7, 'days').format('DD/MM/Y');
            }

            if (is_trial || access_stops_on !== null) {
                return t('subscriptionsExpiresOn') + endDate;
            } else {
                return t('subscriptionsAutoRenewalOn') + endDate;
            }
        }

        return null;
    }

    render() {
        const {
            t,
            subscription: {
                id,
                name,
                price,
                status,
                status_string,
                created_at,
                trial_end_date,
                last_payment_date,
                next_payment_date,
                trial_end_days,
                course_id,
                is_expired,
                ds24_rebilling_stop_url,
                access_stops_on,
                ds24_renew_url,
                ds24_receipt_url,
                is_trial,
                interval
            }
        } = this.props;

        const isActive = !is_expired;
        const actionUrl = isActive ? ds24_rebilling_stop_url : ds24_renew_url;

        return <>
            <div className="item mb-4">
                <div className={'row'}>
                    <div className={'col-md d-md-none mb-1'}><span className={'th'}>{ t('subscriptionsType') }</span></div>
                    <div className={'col-xs-12 col-sm'}><span>{ name }</span></div>

                    <div className={'col-md d-md-none mb-1 mt-3'}><span className={'th'}>{ t('subscriptionsDetails') }</span></div>
                    <div className={'col-xs-12 col-sm'}>
                        { !isActive && <>{ t('subscriptionsExpiresOn') }: { Helpers.calculateEndDate(this.props.subscription) }<br /></> }
                        { isActive && <>{this._getExpireMessage()}<br /></> }
                    </div>

                    <div className={'col-xs-12 col-sm'}>
                        {/*<button
                            onClick={() => this.isViewVisible = !this.isViewVisible}
                            className={'btn btn-secondary mt-2'}
                        >{ this.isViewVisible ? 'Hide' : 'View' }</button>*/}

                        <UncontrolledButtonDropdown>
                            <div className="btn-group">
                                { /*actionUrl && actionUrl.length && (
                                    <a href={isActive ? ds24_rebilling_stop_url : ds24_renew_url}
                                       target={'_blank'}
                                       type="btn"
                                       className={classnames('btn', { 'btn-danger': isActive, 'btn-secondary': !isActive })}
                                    >{ !isActive ? 'Renew' : 'Cancel' }</a>
                                )*/}

                                <DropdownToggle
                                    caret
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    className={'btn dropdown-toggle dropdown-toggle-split btn-light'}>
                                    <span className={'mr-2'}>{ t('subscriptionsClickForOptions') }</span>
                                    <span className="sr-only">Toggle Dropdown</span>
                                </DropdownToggle>

                                <DropdownMenu right>
                                    { interval > 0 && <Link className="dropdown-item" to={`/subscriptions/${course_id}`}>{ t('subscriptionsChange') }</Link> }
                                    { ds24_renew_url && is_expired && <a className="dropdown-item" target={'_blank'} href={ds24_renew_url}>{ t('subscriptionsRenew') }</a> }
                                    { ds24_receipt_url && <a className="dropdown-item" target={'_blank'} href={ds24_receipt_url}>{ t('subscriptionsChangePaymentMethod') }</a> }
                                    { ds24_rebilling_stop_url && interval > 0 && !is_expired && <a className="dropdown-item" target={'_blank'} onClick={e => {
                                        e.preventDefault();
                                        this.toggleCancelModal();
                                    }}>{ t('subscriptionsCancel') }</a> }
                                </DropdownMenu>
                            </div>
                        </UncontrolledButtonDropdown>

                        {/*<div className="btn-group">
                            <button
                                type="button"
                                className={classnames('btn', { 'btn-danger': expires, 'btn-secondary': expired })}
                            >{ expired ? 'Renew' : 'Cancel' }</button>

                            <button
                                className={classnames('btn dropdown-toggle dropdown-toggle-split', { 'btn-danger': expires, 'btn-secondary': expired })}
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <span className="sr-only">Toggle Dropdown</span>
                            </button>
                            <div className="dropdown-menu">
                                <a className="dropdown-item" href="#">Change payment method</a>
                            </div>
                        </div>*/}
                    </div>
                </div>
            </div>

            <Modal isOpen={this.isModalVisible} toggle={this.toggleCancelModal}>
                <ModalHeader toggle={this.toggleCancelModal}>{ t('subscriptionsCancelModalTitle') }</ModalHeader>
                <ModalBody>
                    {t('subscriptionsCancelModalContent', { name, endDate: Helpers.calculateEndDate(this.props.subscription) })}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.cancel}>{ t('subscriptionsCancelModalAgree') }</Button>{' '}
                    <Button color="secondary" onClick={this.toggleCancelModal}>{ t('subscriptionsCancelModalCancel') }</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={this.isCancelledVisible} toggle={this.toggleCancelModal}>
                <ModalBody>
                    Cancellation request was sent. Your subscription will be cancelled shortly
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => this.isCancelledVisible = false}>OK</Button>
                </ModalFooter>
            </Modal>

            { this.isViewVisible && (
                <div className="card mb-5">
                    <div className="card-body">
                        <button className={'btn btn-secondary mr-1'}>{ t('subscriptionsChangePaymentMethod') }</button>
                        <button className={'btn btn-danger'}>{ t('subscriptionsCancel') }</button>
                    </div>
                </div>
            )}
        </>
    }

}
